export const BOOK_PATH_SEPARATOR = ' > ';

export const BOOK_TYPES = ['New', 'Used', 'Digital (eBook)', 'Audiobook'];

export const BOOK_LANGUAGES = ['Arabic', 'English', 'French', 'German', 'Other'];

export const BOOK_AUDIENCES = ['Children', 'Young Adult', 'Adult', 'Academic'];

export const BOOKS_CATEGORY_TREE = {
  'Education & Academic': {
    'School Books': ['Primary Education', 'Middle School', 'High School'],
    'University & College': [
      'Engineering',
      'Medicine',
      'Pharmacy',
      'Dentistry',
      'Nursing',
      'Computer Science',
      'Business Administration',
      'Economics',
      'Law',
      'Architecture',
      'Arts & Design',
      'Agriculture',
      'Education',
      'Psychology',
      'Political Science',
      'Languages & Literature',
      'Other Academic Subjects',
    ],
    'Study Aids': ['Exam Preparation', 'Test Banks', 'Reference Books', 'Workbooks'],
  },
  'Business & Career': {
    Entrepreneurship: ['Startups', 'Small Business', 'Innovation'],
    Management: ['Leadership', 'Project Management', 'Operations'],
    Finance: ['Investing', 'Personal Finance', 'Accounting'],
    'Marketing & Sales': ['Digital Marketing', 'Branding', 'Sales'],
    'Career Development': ['Job Hunting', 'Productivity', 'Professional Skills'],
  },
  'Technology & Computing': {
    Programming: ['Web Development', 'Mobile Development', 'Software Engineering', 'Game Development'],
    'Data & AI': ['Data Science', 'Machine Learning', 'Artificial Intelligence'],
    'IT & Infrastructure': ['Networking', 'Cloud Computing', 'Cybersecurity', 'Databases'],
    'Technology Topics': ['Blockchain', 'Robotics', 'Emerging Technologies'],
  },
  'Self-Development': {
    'Personal Growth': ['Habits', 'Motivation', 'Success'],
    Productivity: ['Time Management', 'Goal Setting'],
    Communication: ['Public Speaking', 'Negotiation', 'Relationships'],
    'Mental Wellness': ['Mindfulness', 'Emotional Intelligence'],
  },
  'Health & Medicine': {
    'Medical Sciences': ['Anatomy', 'Physiology', 'Pathology'],
    'Clinical Medicine': ['Internal Medicine', 'Surgery', 'Pediatrics', 'Dermatology'],
    Healthcare: ['Nursing', 'Public Health', 'Nutrition'],
    'Fitness & Wellness': ['Exercise', 'Healthy Living'],
  },
  'Law & Politics': {
    Law: ['Civil Law', 'Criminal Law', 'Corporate Law', 'International Law'],
    Politics: ['Political Science', 'Public Policy', 'Government'],
    'International Relations': ['Diplomacy', 'Geopolitics'],
  },
  Science: {
    'Physical Sciences': ['Physics', 'Chemistry'],
    'Life Sciences': ['Biology', 'Zoology', 'Botany'],
    'Earth & Space': ['Geology', 'Astronomy', 'Environmental Science'],
    Mathematics: ['Algebra', 'Calculus', 'Statistics'],
  },
  'Arts, Design & Photography': {
    Art: ['Drawing', 'Painting', 'Sculpture'],
    Design: ['Graphic Design', 'Interior Design', 'Fashion Design'],
    Photography: ['Digital Photography', 'Photo Editing'],
    'Music & Performing Arts': ['Music Theory', 'Acting', 'Dance'],
  },
  'Literature & Fiction': {
    Fiction: [
      'Romance',
      'Mystery & Thriller',
      'Fantasy',
      'Science Fiction',
      'Historical Fiction',
      'Horror',
      'Adventure',
    ],
    Literature: ['Classic Literature', 'Poetry', 'Drama'],
    'Graphic Novels': ['Comics', 'Manga'],
  },
  'History & Culture': {
    History: ['Ancient History', 'Medieval History', 'Modern History'],
    Culture: ['Civilizations', 'Anthropology'],
    'Military History': ['General'],
    'Biographies & Memoirs': ['General'],
  },
  'Travel & Languages': {
    Travel: ['Travel Guides', 'Adventure Travel'],
    'Language Learning': ['English', 'Arabic', 'French', 'German', 'Spanish', 'Other Languages'],
    'Dictionaries & Reference': ['General'],
  },
  "Children's Books": {
    'Early Learning': ['Alphabet & Numbers', 'Educational Books'],
    'Story Books': ['Picture Books', 'Bedtime Stories'],
    'Young Readers': ['Chapter Books', 'Young Adult (YA)'],
  },
  'Religion & Spirituality': {
    Islam: ['Quran & Tafsir', 'Hadith', 'Fiqh', 'Islamic History'],
    Christianity: ['General'],
    'Comparative Religion': ['General'],
    'Spirituality & Personal Faith': ['General'],
  },
  'Hobbies & Lifestyle': {
    Cooking: ['Cookbooks', 'Baking'],
    Crafts: ['DIY', 'Sewing', 'Knitting'],
    Gardening: ['General'],
    'Pets & Animals': ['General'],
    'Sports & Recreation': ['General'],
    'Collectibles & Special Interests': ['General'],
  },
  'Reference & Other Books': {
    Encyclopedias: ['General'],
    Dictionaries: ['General'],
    Atlases: ['General'],
    'Rare & Collectible Books': ['General'],
    'Other Books': ['General'],
  },
};

export const BOOK_SECTIONS = Object.keys(BOOKS_CATEGORY_TREE);

export function isBooksListingCategory(category) {
  return category === 'Books';
}

export function joinBookSubcategoryPath(parts) {
  return parts.filter(Boolean).join(BOOK_PATH_SEPARATOR);
}

export function parseBookSubcategoryPath(value) {
  if (!value) {
    return { section: '', group: '', topic: '' };
  }
  const [section = '', group = '', topic = ''] = String(value).split(BOOK_PATH_SEPARATOR);
  return { section, group, topic };
}

export function getBookGroups(section) {
  return Object.keys(BOOKS_CATEGORY_TREE[section] || {});
}

export function getBookTopics(section, group) {
  const node = BOOKS_CATEGORY_TREE[section]?.[group];
  return Array.isArray(node) ? node : [];
}
